import Api from './ApiRequest';

export default {
    getAll: () => Api.get('/cent/settings'),
    save: (setting) => Api.put(`/cent/setting/${setting.name}`, setting),
};